module.exports = __webpack_public_path__ + "img/reshares.763faa4a.png";